import React from 'react';

export const Send: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="4 4 16 16" {...props}>
    <path
      d="M19 5L5 12.875l4.474 1.657 6.9-6.47-5.248 7.082h-.005V19l2.509-2.927 3.178 1.177z"
      fill="currentColor"
    />
  </svg>
);
